import {
  IconButton,
  InputAdornment,
  Paper,
  TextField,
} from "@material-ui/core";
import AddCommentIcon from "@material-ui/icons/AddComment";
import { Field, Form, Formik } from "formik";
import React, { useContext } from "react";
import useApi from "../../../../../../../hooks/api";
import useAuth from "../../../../../../../hooks/auth";
import { CrmContext } from "../../../../context";

export default () => {
  const {
    tradeId,
    trade: { comments },
    updateComments,
  } = useContext(CrmContext);
  const { post } = useApi();
  const { user } = useAuth();

  const initialValues = {
    text: "",
    commented_by: user.id,
    parent_comment: null,
    crm_trade_id: tradeId,
  };

  const createComment = (values, actions) => {
    if (values.text == "") return;

    actions.setSubmitting(true);

    post(`/v1/crm/trades/${tradeId}/comments`, values)
      .then((response) => {
        updateComments(response.data);
      })
      .catch((err) => {
        alert(
          "Atenção! Não conseguimos criar seu comentário. Tente novamente mais tarde. Se o problema persistir, entre em contato conosco."
        );
      });

    actions.resetForm();

    actions.setSubmitting(false);
  };

  const handleDisplayComments = (comments) => {
    return (
      <>
        {comments
          ?.sort((a, b) => b.id - a.id)
          .map((comment, i) => {
            const commentDate = comment.created_at;
            const parseDate = commentDate.substring(0, 10);
            const parseHours = commentDate.substring(11, 16);

            return (
              <div key={comment.id} className="crm-trade-comment-area">
                <span>
                  <b>{parseDate} </b>
                  às
                  <b> {parseHours}</b>
                  {` `}por{` `}
                  <b>{comment.commenter.name}</b>
                  {` `}:{` `}
                </span>
                <span>{comment.text}</span>
              </div>
            );
          })}
      </>
    );
  };

  return (
    <div className="crm-card-modal-section">
      <div className="crm-trade-basic-title mb-15">COMENTÁRIOS</div>

      <Formik initialValues={initialValues} onSubmit={createComment}>
        {(formik) => (
          <>
            <Form component={Paper}>
              <Field name="text">
                {() => {
                  return (
                    <TextField
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              color="primary"
                              aria-label="create"
                              size="medium"
                              type="submit"
                              disabled={!formik.dirty}
                            >
                              <AddCommentIcon fontSize="inherit" />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      multiline
                      fullWidth
                      label="Novo comentário"
                      name="text"
                      variant="outlined"
                      value={formik.values.text}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                  );
                }}
              </Field>
            </Form>
          </>
        )}
      </Formik>
      {handleDisplayComments(comments)}
    </div>
  );
};
